import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetModulesListQuery } from '../../../api/queries/getModulesList';
import { ModuleType } from '../../../api/types';
import { useCompanyContext } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import CustomerList from './CustomerList';
import { useCustomerDownloadModal } from './DownloadModal';

const CustomerListPage = () => {
    const { t } = useTranslation('customerList');
    const [moduleListByApplication, setModuleListByApplication] = useState<string[]>([]);

    const { companies } = useCompanyContext();

    const { data, loading } = useGetModulesListQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            filter: {
                companyIds: companies.map(company => company.id),
                moduleTypes: [
                    ModuleType.FinderApplicationPublicModule,
                    ModuleType.FinderApplicationPrivateModule,
                    ModuleType.StandardApplicationModule,
                    ModuleType.EventApplicationModule,
                    ModuleType.MobilityModule,
                    ModuleType.ConfiguratorModule,
                ],
            },
        },
    });

    const moduleIds = useMemo(() => (data?.modules?.items || []).map(module => module.id), [data]);

    const customerDownloadModal = useCustomerDownloadModal(moduleListByApplication);
    const extra = (
        <Button icon={<DownloadOutlined />} onClick={customerDownloadModal.open} type="primary">
            {t('customerList:actions.download')}
        </Button>
    );

    if (!data?.modules?.items || loading) {
        return null;
    }

    return (
        <ConsolePageWithHeader extra={extra} title={t('customerList:title')}>
            <CustomerList moduleIds={moduleIds} setModuleListByApplication={setModuleListByApplication} />
            {customerDownloadModal.render({ forAdmin: true })}
        </ConsolePageWithHeader>
    );
};

export default CustomerListPage;
